// extracted by mini-css-extract-plugin
module.exports = {"searchControl":"HeroSearch_searchControl__sGfgy","compact":"HeroSearch_compact__EjY0_"};